export default "__VITE_ASSET__BqiKRksV__"